(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    if (!reduce.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('pn-waiting'); observer.unobserve(entry.target); }
      }), { threshold: 0.08 });
      root.querySelectorAll('[data-pn-reveal], .pn-universe .pn-category, #MainContent .resource-list__item, .pn-arrival__copy, .pn-arrival__photos, .pn-trust, .pn-reviews').forEach(el => {
        if (el.dataset.pnObserved) return;
        el.dataset.pnObserved = '1'; el.classList.add('pn-reveal');
        if (el.getBoundingClientRect().top > window.innerHeight) el.classList.add('pn-waiting');
        observer.observe(el);
      });
    }
    root.querySelectorAll('.pn-marquee__toggle').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = '1';
      button.addEventListener('click', () => {
        const paused = button.closest('.pn-marquee').classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
        button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      });
    });
    root.querySelectorAll('.pn-experience__video').forEach(video => {
      if (video.dataset.bound) return;
      video.dataset.bound = '1';
      const button = video.closest('.pn-experience').querySelector('.pn-video-toggle');
      const sync = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
      const saveData = navigator.connection?.saveData;
      if (!reduce.matches && !saveData) video.play().then(sync).catch(sync);
      video.addEventListener('play', sync); video.addEventListener('pause', sync);
      button.addEventListener('click', () => { if (video.paused) video.play().catch(sync); else video.pause(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
      reduce.addEventListener('change', () => { if (reduce.matches) video.pause(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  reduce.addEventListener('change', () => { if (reduce.matches) document.querySelectorAll('.pn-waiting').forEach(el => el.classList.remove('pn-waiting')); });
})();
